import { render, staticRenderFns } from "./Pagebody.vue?vue&type=template&id=002b2e5e&scoped=true"
import script from "./Pagebody.vue?vue&type=script&lang=js"
export * from "./Pagebody.vue?vue&type=script&lang=js"
import style0 from "./Pagebody.vue?vue&type=style&index=0&id=002b2e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b2e5e",
  null
  
)

export default component.exports